const MATCH_ALL_SPECIAL_CHARACTERS = /[^\w()\s\-_]/g;

export default function scrubSeoInfo(info, regex = MATCH_ALL_SPECIAL_CHARACTERS) {
  return info.replace(regex, '').split(/\s/).join('-');
}
